import React from 'react';


class Callus extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding p-tb80 overlay-wraper" style={{position: 'relative', overflow: 'hidden'}}>
                    <video style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover'}} autoPlay loop muted>
                        <source src={require('./../../assets/media/video/arena.mp4')} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <div className="overlay-main bg-primary opacity-02" style={{position: 'absolute', width: '100%', height: '100%'}} />
                    <div className="container" style={{position: 'relative', zIndex: 2}}>  {/* Z-index added to ensure content is on top */}
                        <div className="section-content">
                            <div className="call-us-section text-center">
                                <h4 className="call-us-text m-b15 text-light">Zapraszamy jednostki samorządu
terytorialnego, firmy,biura
projektowe, kluby sportowe,
klientów indywidualnych oraz
społeczności lokalne do współpracy
w tworzeniu nowoczesnych i
bezpiecznych przestrzeni do
rozwoju sportów miejskich.</h4>
                                <h2 className="call-us-number m-b15 m-b0">PL +48 500 073 261</h2>
                                <h2 className="call-us-number m-b15 m-b0">ENG/PL +48 602 762 478</h2>
                                <h4 className="call-us-address call-us-text m-t0 m-b20">Pokoleń Lechii Gdańsk 1</h4>
                                <a className="site-button-secondry btn-effect bg-dark" href="mailto:biuro@skate-arena.pl?subject=Budowa skateparku w [ MIEJSCE ] &body=Dzień dobry.%0A%0AUprzejmie proszę o kontakt w sprawie budowy skateparku. Mój telefon to: [Twój numer telefonu]%0APozdrawiam.%0A%0A[Twoje Imie i Nazwisko]%0A%0A[Instytucja]">Jesteś zainteresowany/a? Wyślij do nas email!</a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Callus;
